export default "__VITE_ASSET__6CplQ1lS__"